import React, { Component } from "react";
import momentjalali from "moment-jalaali";

export default class CashierDateTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateValue: momentjalali().format("jYYYY/jM/jD"),
      timeValue: momentjalali().format("HH:mm"),
    };
    setInterval(() => {
      this.setState({
        dateValue: momentjalali().format("jYYYY/jM/jD"),
        timeValue: momentjalali().format("HH:mm"),
      });
    }, 1000);
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          flex: "1",
          gap: "16px",
          fontSize: "16px",
          fontWeight: "400",
        }}
      >
        <div>{this.state.dateValue}</div>
        <div>{this.state.timeValue}</div>
      </div>
    );
  }
}
